/* ed-custom-request.js: Custom Order Request page only. Loaded with defer.
   1) Relabels the add-to-cart button "Submit Request" (text AND Stretch's
      rotated-text / up-text hover attributes, which otherwise show "Add to cart").
   2) After the request is added to the cart, sends the customer straight to
      checkout (cart drawer hidden during submit so it never flashes). Three independent triggers so it works no matter how the add
      happens (Stretch fetch, Easify XHR, or a full form post):
        a) fetch wrapper, b) XMLHttpRequest wrapper, c) after a Submit click,
        poll /cart.js for the Custom Order Request item (up to 10s).
   3) Hides the Essential Estimated shipping widget on this page.
   4) When Order Type = "Business / Organization", disables Submit so business
      requests go through /pages/business-bulk-orders. */
(function () {
  /* Test switch: add ?edoff=1 to the URL to run the page with this script OFF */
  if (/[?&]edoff=1/.test(location.search)) { console.info('[ED CR] script disabled via ?edoff=1'); return; }
  var LABEL = 'Submit Request';
  var HANDLE = 'custom-order-request';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Easify swaps the theme's submit button for its own type="button" .tpo_add-to-cart */
  var BTN_SEL = 'product-form form[action*="/cart/add"] button[type="submit"], product-rerender .tpo_add-to-cart';

  /* 1) Label */
  function relabel() {
    document.querySelectorAll(BTN_SEL).forEach(function (btn) {
      if (btn.dataset.edBiz === '1') return;
      var bc = btn.querySelector('button-content');
      if (bc) {
        ['rotated-text', 'up-text'].forEach(function (a) {
          if (bc.hasAttribute(a) && bc.getAttribute(a) !== LABEL) bc.setAttribute(a, LABEL);
        });
      }
      if (!/add to cart/i.test(btn.textContent)) { if (btn.getAttribute('aria-label') !== LABEL) btn.setAttribute('aria-label', LABEL); return; }
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), n, first = true;
      while ((n = walker.nextNode())) {
        if (!n.nodeValue.trim()) continue;
        if (first) { if (n.nodeValue !== LABEL) n.nodeValue = LABEL; first = false; }
        else if (n.nodeValue !== '') n.nodeValue = '';
      }
      if (btn.getAttribute('aria-label') !== LABEL) btn.setAttribute('aria-label', LABEL);
    });
  }

  /* 2) Redirect to checkout */
  var going = false;
  /* Wait until cart writes stop (Easify may add fee add-ons right after the
     main item), then go. Debounced: each new add/update resets the timer. */
  var goTimer = null;
  function goCheckout() {
    if (going) return;
    document.documentElement.classList.add('ed-cr-submitting');
    clearTimeout(goTimer);
    goTimer = setTimeout(function () { going = true; window.location.replace(ROOT + 'checkout'); }, 450);
  }
  function isAdd(url) { return /\/cart\/(add|update|change)/.test(url || ''); }
  if (window.fetch && !window.__edCrFetch) {
    window.__edCrFetch = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var p = origFetch.apply(this, arguments);
      if (/\/cart/.test(url)) console.info('[ED CR] fetch ->', url);
      return p.then(function (res) {
        try {
          if (/\/cart/.test(url)) console.info('[ED CR] fetch <-', url, res.status);
          if (res.ok && isAdd(url)) goCheckout();
          if (!res.ok && isAdd(url)) res.clone().text().then(function (t) { console.warn('[ED CR] cart/add failed:', res.status, t.slice(0, 300)); });
        } catch (e) {}
        return res;
      }, function (err) { console.warn('[ED CR] fetch error', url, err); throw err; });
    };
  }
  if (window.XMLHttpRequest && !window.__edCrXhr) {
    window.__edCrXhr = true;
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      this.__edUrl = url;
      this.addEventListener('load', function () {
        try {
          if (/\/cart/.test(this.__edUrl || '')) console.info('[ED CR] xhr <-', this.__edUrl, this.status);
          if (this.status >= 200 && this.status < 300 && isAdd(this.__edUrl)) goCheckout();
          if (this.status >= 400 && isAdd(this.__edUrl)) console.warn('[ED CR] cart/add failed:', this.status, String(this.responseText || '').slice(0, 300));
        } catch (e) {}
      });
      return origOpen.apply(this, arguments);
    };
  }
  function pollCart() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (going || tries > 20) { clearInterval(t); return; }
      fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var hit = (c.items || []).some(function (i) { return i.handle === HANDLE; });
        if (hit) { clearInterval(t); goCheckout(); }
      }).catch(function () {});
    }, 500);
  }
  /* 2b) Hidden-required fix + diagnostics. Browsers silently refuse to submit
     a form when a REQUIRED field is hidden (e.g. an Easify conditional field
     that isn't showing). Before submit, drop 'required' from hidden fields and
     log anything still invalid to the console as [ED CR]. */
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function prepSubmit(btn) {
    var form = btn.form || btn.closest('form');
    var fields = [];
    if (form) { fields = Array.prototype.slice.call(form.elements || []); }
    document.querySelectorAll('product-rerender [required]').forEach(function (el) { if (fields.indexOf(el) < 0) fields.push(el); });
    fields.forEach(function (el) {
      if (el.required && el.type !== 'hidden' && !visible(el)) {
        el.required = false; el.setAttribute('data-ed-req-removed', '1');
        console.info('[ED CR] removed required from hidden field:', el.name || el.id);
      }
    });
    var bad = fields.filter(function (el) { return el.willValidate && !el.checkValidity(); });
    if (bad.length) console.warn('[ED CR] still invalid:', bad.map(function (el) { return (el.name || el.id) + ' — ' + el.validationMessage; }));
    else console.info('[ED CR] form valid, submitting');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(BTN_SEL);
    if (btn && !btn.disabled) {
      /* hide the cart drawer while the request is added, so the customer goes straight to checkout */
      var html = document.documentElement; html.classList.add('ed-cr-submitting');
      setTimeout(function () { if (!going) html.classList.remove('ed-cr-submitting'); }, 12000);
      console.info('[ED CR] submit clicked:', btn.className); try { prepSubmit(btn); } catch (err) { console.warn('[ED CR]', err); } pollCart(); }
  }, true);
  window.addEventListener('error', function (e) { console.warn('[ED CR] page error:', e.message, e.filename + ':' + e.lineno); });
  window.addEventListener('unhandledrejection', function (e) { console.warn('[ED CR] promise rejected:', e.reason && (e.reason.message || e.reason)); });

  /* 3) Hide shipping-estimate custom elements (CSS covers class/id matches) */
  function hideEta() {
    var root = document.querySelector('product-rerender');
    if (!root) return;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.tagName.indexOf('ESTIMAT') > -1 && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
    });
  }

  /* 4) Business guard */
  var BIZ = /business\s*\/\s*organization/i;
  function businessSelected() {
    var root = document.querySelector('product-rerender') || document, hit = false;
    root.querySelectorAll('input:checked, select').forEach(function (el) {
      var v = el.tagName === 'SELECT' ? ((el.options[el.selectedIndex] || {}).text || el.value) : el.value;
      var lbl = el.labels && el.labels[0] ? el.labels[0].textContent : '';
      if (BIZ.test(v || '') || (el.tagName !== 'SELECT' && BIZ.test(lbl))) hit = true;
    });
    return hit;
  }
  function businessGuard() {
    var biz = businessSelected();
    document.querySelectorAll(BTN_SEL).forEach(function (btn) {
      if (biz && !btn.disabled) { btn.disabled = true; btn.dataset.edBiz = '1'; }
      else if (!biz && btn.dataset.edBiz === '1') { btn.disabled = false; delete btn.dataset.edBiz; }
    });
    var note = document.querySelector('.ed-cr-biz-note');
    if (note) note.hidden = !biz;
  }
  document.addEventListener('change', businessGuard, true);

  function run() { businessGuard(); relabel(); hideEta(); }
  run();
  document.addEventListener('DOMContentLoaded', run);
  var pr = document.querySelector('product-rerender');
  if (pr) new MutationObserver(run).observe(pr, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['rotated-text', 'up-text'] });
})();
